const MOBILE_WIDTH = 719;

const httpMatch = (url) => {
  return url.match(/^(https?:\/\/|mailto:)/i);
};

export default {
  props: {
    provider: { type: Object },
    extendedCard: { type: Boolean },
    index: { type: String },
    blured: { type: Boolean },
    beforeSamplePlay: { type: Object },
    section: { type: String },
    keyword: { type: String },
    bookingQuote: { type: String },
    lastActiveText: { type: String },
    forceLinkDefault: { type: Boolean, detault: false }
  },

  data() {
    return {
      format: {
        relativeTime: undefined,
        vdlCurrencyFormatter: undefined,
        date: undefined
      },
      currentService: 'voice_over'
    };
  },

  computed: {
    providerUrl() {
      let url = 'https://voice123.com/' + this.provider.user.username;
      const relevantSample = this.provider.relevant_sample;

      if (relevantSample && relevantSample.id) {
        url += `?sample=${relevantSample.id}`;
      }
      return url;

    },

    userInfo() {
      const title = ( this.provider.user.roles && this.provider.user.roles.includes('tester') ? '[TEST]' : '' ) + this.provider.user.name;

      return {
        title: title,
        thumbPath: this.provider.user.picture_small || '/static/profile_pic.png',
        subhead: this.provider.recommendations,
        membershipTypeId: this.provider && this.provider.membership_product_name,
        membership_start_timestamp: this.provider && this.provider.membership_start_timestamp,
        mainContent: this.provider.headline,
        id: this.provider.id,
        stats: this.provider.stats,
        lastInteraction: this.provider.user.last_interaction,
        firstName: this.provider.user.name.split(' ')[0],
        user: this.provider.user
      };
    },

    audioInfo() {
      let media = this.provider.relevant_sample || this.provider.samples && this.provider.samples[0];

      if (media.file ||  media.url) {
        media.ref = `audio-${media.display_order}`;
        media.url = httpMatch(media.file) ? media.file : '//voice123.com/mp3/' + media.file;
      }
      return media || {};
    },

    displayableDescription() {
      const word = this.keyword.toLowerCase();
      const description = this.provider.description;
      let ans = description;

      if (description.toLowerCase().includes(word)) {
        const paragraphs = description.split('.');

        ans = paragraphs.reduce((acc, current) => {
          if (current.includes(word)) {
            ans += `${current}. `;
          }
          return ans;
        }, '');
      }

      if (window.innerWidth <= MOBILE_WIDTH) {
        if (ans.length > 100) {
          ans = this.provider.description.substring(0, 100) + '...';
        }
      } else {
        if (ans.length > 200) {
          ans = this.provider.description.substring(0, 200) + '...';
        }
      }

      return ans;
    },

    providerRating() {
      if (this.provider.stats && this.provider.stats.reviews_rating) {
        return this.provider.stats.reviews_rating.toFixed(1);
      }
    },

    showBlured() {
      return this.blured;
    },

    underMobileWidth() {
      return window.innerWidth <= MOBILE_WIDTH;
    },

    showActionsSlots() {
      return true;
    }
  },

  methods: {
    onSignUp() {
      this.$emit('sign-up', this.provider);
    },

    onAudioListened() {
      this.$emit('audio-listened', this.provider.relevant_sample);
    },

    onClick(e) {
      if (!e || e && e.target && e.target.className !== 'vdl-icon-badge') {
        if (this.$listeners && this.$listeners['click:profile']) {
          if (!this.forceLinkDefault) {
            e.preventDefault();
          }

          this.$emit('click:profile', this.providerUrl);
        }
      }
    }
  }
};